// extracted by mini-css-extract-plugin
export default {"root":"_216_M2SHHE2VmcfQaRKTYV","header":"oR02MN9NzWk_QHTxGu9Gh","documentationLinkContainer":"_1hKOMbLlQ6ongncdAp0CJ4"};